<div class="form-container">
  <div class="header">
    <div class="header-item">Účetní jednotka: {{ entityId }}</div>
    <div class="header-item">Účetní období: {{ kodUo }}</div>
  </div>
  <div class="form">
    <table>
      <thead>
      <tr>
        @for (col of columns; track col.name) {
          <th>{{ col.title }}</th>
        }
        <th></th>
      </tr>
      </thead>
      <tbody>
        @for (group of formGroup; track group.value.kod; let groupIndex = $index) {
          <tr>
            <ng-container [formGroup]="group">
              @if (isEdit) {
                @for (col of columns; track col.name) {
                  @if (col.name === 'kod') {
                    <td class="{{col.type}}">
                      {{ formGroup[groupIndex].value[col.name] }}
                    </td>
                  } @else {
                    <td class="{{col.type}}">
                      <mat-form-field class="table-field">
                        <input [formControlName]="col.name" matInput class="table-input">
                      </mat-form-field>
                    </td>
                  }
                }
              } @else {
                @for (col of columns; track col.name) {
                  <td class="{{col.type}}">
                    {{ formGroup[groupIndex].value[col.name] }}
                  </td>
                }
              }
            </ng-container>
            <td>
              <button mat-button (click)="delete(groupIndex)">
                <i class="cml-fw cml-lg cml-trash-o" [attr.active-color]="'cml-active-red'"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

